import React from "react";
import { cn } from "@/lib/utils";

export function Panel({ className, children, ...props }) {
  return (
    <div className={cn("rounded-xl border border-line bg-card", className)} {...props}>
      {children}
    </div>
  );
}

export function PanelHeader({ title, children, className }) {
  return (
    <div className={cn("flex items-center justify-between border-b border-line px-4 py-3", className)}>
      <h3 className="font-display text-lg font-semibold text-ink">{title}</h3>
      {children}
    </div>
  );
}
